<template>
    <div id="dashboard-report-order">
      <h3>Gestão de Pedidos</h3>
      <span>Aqui você pode extrair uma tabela ou planilha com o relatório de uso da plataforma dos seus atendentes</span>
      <vs-alert
        title="Aviso"
        active="true"
        class="mb-8 mt-8"
        color="warning"
      >
        Preencha os campos abaixo para extrair um relatório
      </vs-alert>
      <div class="vx-row">
        <div class="vx-col w-full md:w-1/4 lg:w-1/4 xl:w-1/4 mb-base">
          <div class="w-12/12">
            <div class="w-full justify-center items-center">
              <span class="phone-number-span mr-12">
                Período (de)
              </span>
            </div>
  
            <div class="w-full">
              <flat-pickr
                :config="configdateTimePicker"
                v-model="start_at"
                name="Período (de)"
                placeholder="Escolha um dia"
                v-validate="'required'"
              />
  
              <div class="clear: both;">
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('Período (de)')"
                >
                  {{ errors.first('Período (de)') }}
                </span>
              </div>
            </div>
          </div>
        </div>
  
        <div class="vx-col w-full md:w-1/4 lg:w-1/4 xl:w-1/4 mb-base">
          <div class="w-12/12">
            <div class="w-full justify-center items-center">
              <span class="phone-number-span mr-12">
                Período (até)
              </span>
            </div>
  
            <div class="w-full">
              <flat-pickr
                :config="finishAtConfig(configdateTimePicker)"
                v-model="finish_at"
                name="Período (até)"
                placeholder="Escolha um dia"
                v-validate="'required'"
                :disabled="start_at === ''"
              />
  
              <div class="clear: both;">
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('Período (até)')"
                >
                  {{ errors.first('Período (até)') }}
                </span>
              </div>
            </div>
          </div>
        </div>
  
        <div class="vx-col w-full md:w-1/4 lg:w-1/4 xl:w-1/4 mb-base">
          <div class="w-12/12">
            <div class="w-full justify-center items-center">
              <span class="phone-number-span">Tipo</span>
            </div>
  
            <v-select
              class="w-full" v-model="type"
              :options="types"
              name="Tipo"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-validate="'required'"
            />
  
            <div class="clear: both;">
              <span
                class="text-danger text-sm"
                v-show="errors.has('Tipo')"
              >
                {{ errors.first('Tipo') }}
              </span>
            </div>
          </div>
        </div>   
      </div>
        
      <div class="vx-row" v-if="reportUser === 'specific'">
        <vs-card>
          <div>
            <users-table @chooseUser="chooseUser" :selected-users="selectedUsers" />
          </div>
        </vs-card>
      </div>
  
      <div  class="vx-row">
        <div class="vx-col w-full">
          <div class="w-12/12">
            <div class="w-full">
              <vs-button class="mt-5" color="rgb(0, 205, 216)"  @click="generateSheet">
                Gerar Relatório
              </vs-button>
              <vs-button class="mt-5 ml-4" @click="enterEmail">
                Gerar Relatório em Planilha Via Email
              </vs-button>
            </div>
          </div>
        </div>
        <div id="table-report">
          <div v-if="tabledata.length > 0">
            <vs-dropdown
            vs-trigger-click
            class="cursor-pointer mb-4 mr-4 mt-4"
          >
            <div
                class="
                  p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg
                  cursor-pointer flex items-center justify-between font-medium
                "
            >
              <span class="mr-2">
                {{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
                {{
                      tabledata.length - currentPage * itemsPerPage > 0
                      ? currentPage * itemsPerPage
                      : tabledata.length
                }} de {{ queriedItems }}
              </span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
                <vs-dropdown-menu>
                    <vs-dropdown-item @click="itemsPerPage=4">
                      <span>4</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="itemsPerPage=10">
                      <span>10</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="itemsPerPage=15">
                      <span>15</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="itemsPerPage=20">
                      <span>20</span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
            </div>
      
          <vs-table
            v-if="typetable === 1"
            noDataText="Sem dados disponíveis"
            class="table-report-container mt-4"
            :max-items="itemsPerPage"
            :data="tabledata">
            <template slot="header" >
              <h3 class="mb-3">Relatório: Gestão de Pedidos</h3>
            </template>
            <template slot="thead">
              <vs-th >
                Número do Pedido
              </vs-th>
              <vs-th>
                Nome do Cliente
              </vs-th>
              <vs-th>
                Usuário
              </vs-th>
              <vs-th>
                Protocolo de Atendimento
              </vs-th>
              <vs-th>
                Status do Pedido
              </vs-th>
              <vs-th>
                Data do Encerramento
              </vs-th>
              <vs-th>
                Data do Cancelamento
              </vs-th>
              <vs-th>
                Data de Criação
              </vs-th>
              <vs-th>
                Entrega ou Retirada
              </vs-th>
              <vs-th>
                Valor de Entrega
              </vs-th>
              <vs-th>
                CEP
              </vs-th>
              <vs-th>
                Endereço
              </vs-th>
              <vs-th>
                ERP Vinculado
              </vs-th>
              <vs-th>
                Forma de Pagamento
              </vs-th>
              <vs-th>
                Informações extras de Pagamento
              </vs-th>
              <vs-th>
                Total do Pedido
              </vs-th>
            </template>
  
            <template>
              <vs-tr v-for="dados in tabledata" :key="dados.id" >
                <vs-td>
                    {{ dados.id }}
                </vs-td>
  
                <vs-td >
                  {{ (dados.chatTicket && dados.chatTicket.customer && dados.chatTicket.customer.name) || 'Não definido' }}
                </vs-td>
  
                <vs-td>
                  {{ (dados.user && dados.user.name) || 'Não definido' }}
                </vs-td>
  
                <vs-td>
                  {{ (dados.chatTicket && dados.chatTicket.protocol ) || 'Não definido' }}
                </vs-td>
  
                <vs-td>
                  {{ dados.status.name }}
                </vs-td>
  
                <vs-td>
                  {{ dados.is_finished_at || '--/--/---- --:--:--' }}
                </vs-td>
  
                <vs-td>
                  {{ dados.is_cancelled_at || '--/--/---- --:--:--' }}
                </vs-td>
  
                <vs-td>
                  {{ dados.turned_order_at || '--/--/---- --:--:--' }}
                </vs-td>
  
                <vs-td :class="!hasAddress(dados.address) ? 'no-address' : ''">
                  {{ hasAddress(dados.address) ? (dados.is_delivery ? 'Entrega' : 'Retirada') : '-' }}
                </vs-td>
  
                <vs-td :class="!hasAddress(dados.address) ? 'no-address' : ''">
                  {{ dados.address !== null ? (hasAddress(dados.address) ? parseDeliveryFee(dados.address) : '-') : 'Retirada' }}
                </vs-td>
  
                <vs-td :class="!hasAddress(dados.address) ? 'no-address' : ''">
                  {{ dados.address !== null ? (hasAddress(dados.address) ? parseDeliveryCep(dados.address) : '-') : 'Retirada' }}
                </vs-td>
                
                <vs-td :class="!hasAddress(dados.address) ? 'no-address' : ''">
                  {{ dados.address !== null ? (hasAddress(dados.address) ? parseDeliveryAddress(dados.address) : '-') : 'Retirada' }}
                </vs-td>
  
                <vs-td>
                  {{ dados.erp_id === null ? 'Não Vinculado' :  dados.erp.name }}
                </vs-td>
  
                <vs-td :class="!hasPayment(dados.payment_data) ? 'no-address' : ''">
                  {{ hasPayment(dados.payment_data) ? parsePaymentData(dados.payment_data) : '-' }} 
                </vs-td>
  
                <vs-td>
                  {{ parseExtraPaymentInformation(dados.payment_data) || 'Nenhuma'}} 
                </vs-td>
  
                <vs-td>
                  {{ 'R$ ' + String(dados.purchase_value).replace('.', ',') }} 
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
        <vs-pagination
          v-if="tabledata.length > 0"
          :total="totalPages"
          v-model="currentPage"
          class="mt-4"
        ></vs-pagination> 
      </div>
  
      <report-booking-modal @scheduleReport="generateSheetExcel" />
    </div>
  </template>
  
  <script>
  import axios from 'axios'
  import flatPickr from 'vue-flatpickr-component'
  import { Portuguese } from 'flatpickr/dist/l10n/pt.js'
  import vSelect from 'vue-select'
  import reasonHttp from '@/http/requests/reasons'
  import { reasonType } from "@/supports/reasonSupport";
  
  import VxTimeline from "@/components/timeline/VxTimeline"
  import ChangeTimeDurationDropdown from '@/components/ChangeTimeDurationDropdown.vue'
  import 'flatpickr/dist/flatpickr.css'
  import reportHttp from '@/http/requests/report'
  
  import UsersTable from './UsersTable.vue'
  import ReportBookingModal from './ReportBookingModal/ReportBookingModal.vue'
  import { hasFeature, getCurrentTenant } from '@/utils'
  
  export default {
    data() {
      return {
        tabledata: [],
        typetable: '',
        currentPage: 1,
        itemsPerPage: 4,
        configdateTimePicker: {
          enableTime: false,
          noCalendar: false,
          dateFormat: "d/m/Y",
          locale: Portuguese
        },
        types: [
          (hasFeature('orders') ? {
            id: 1,
            label: 'Gestão de Pedidos'
          }
          : ''
          ),
        ],
        totalPages: 0,
        queriedItems: 0,
        type: '',
        start_at: '',
        finish_at: '',
        reportUser: 'all',
        selectedUsers: [],
        blockedTime: false,
        reasons: [],
        reason: null,
        reportCampaign: 'whatsapp',
      }
    },
    computed: {
      isFormValid() {
        return !this.errors.any()
      }
    },
    watch: {
      type(value) {
        if (!value) {
          this.type       = '';
          this.reasons    = [];
          this.reportUser = 'all';
          return;
        }

        return;
      },
      reportUser(reportUser){
        if (reportUser === 'all') {
          this.selectedUsers = []
        }
      },
      currentPage: function() {
          this.generateSheet()
        
      },
      itemsPerPage: function(e) {
        if (this.currentPage === 1) {
          this.generateSheet()
        } else {
          this.currentPage = 1
        }
        
      },
      reportCampaign() {
        this.tabledata   = [];
        this.currentPage = 1;
      }
    },
    methods: {
      chooseUser(userId) {
        const index = this.selectedUsers.indexOf(userId)
  
        if (index === -1) {
          this.selectedUsers.push(userId)
        } else {
          this.selectedUsers.splice(index, 1)
        }
      },
      generateSheet() {
        const startAt = this.datePtToEng(this.start_at)
        const finishAt = this.datePtToEng(this.finish_at)
        
        window.scrollTo(0,0);
        this.$validator.validateAll().then(result => {
          if (result) {
            this.typetable = this.type.id
            if (this.type.id === 1) {
              reportHttp
                .orderProductivityReport(startAt, finishAt, this.currentPage, this.itemsPerPage)
                .then(res => {
                  const orderProductivityParsedReport = res.data.data.orderProductivityReport
                  this.totalPages = orderProductivityParsedReport.total_pages
                  this.queriedItems = orderProductivityParsedReport.total_items
                  this.tabledata = orderProductivityParsedReport.items
                })
                .catch(err => { console.error(err) })
            } else if (this.type.id === 6) {
              reportHttp
                .loginFailuresProductivityReport(startAt, finishAt, this.selectedUsers, this.currentPage, this.itemsPerPage)
                .then(res => {
                  const { loginFailuresProductivityParsedReport } = res.data.data
                  this.totalPages = loginFailuresProductivityParsedReport.total_pages
                  this.queriedItems = loginFailuresProductivityParsedReport.total_items
                  this.tabledata = loginFailuresProductivityParsedReport.items
                })
                .catch(err => { console.error(err) })
            } else {
              if (!this.reason) {
                alert('Nenhum Resumo de Atendimento selecionado.')
                return
              }
            }
          } else {
            window.scrollTo(0, 0);
          }
        })
      },
      generateSheetExcel(email) {
        const startAt = this.datePtToEng(this.start_at)
        const finishAt = this.datePtToEng(this.finish_at)
  
        window.scrollTo(0,0);
        this.$validator.validateAll().then(result => {
          if (result && !this.blockedTime) {
            if (this.type.id === 1) {
              reportHttp
                .orderReportExcel(startAt, finishAt, email)
                .then(() => {
                  this.setTime();
                  this.scheduled(email);
                })
                .catch(err => { console.error(err) })
            } else if (this.type.id === 6) {
              reportHttp
                .loginFailuresProductivityReportExcel(startAt, finishAt, this.selectedUsers, email)
                .then(() => {
                  this.setTime();
                  this.scheduled(email);
                })
                .catch(err => { console.error(err,  'Error') })
            }
          } else {
            this.schedulingTime();
            window.scrollTo(0, 0);
          }
        })
      },
  
      downloadXlsx(url) {
        let reportName = 'Relatório'
  
        if (this.type.id === 6) {
          reportName += ' Falhas no Login';
        }
        
        reportName += ` ${this.datePtToEng(this.start_at)} até ${this.datePtToEng(this.finish_at)}`
  
        axios
          .get(url, {
            responseType: 'blob'
          }).then(res => {
            var blob = new Blob(
              [res.data],
              {
                type: `application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8;`
              }
            )
  
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = `${reportName}.xlsx`
            link.click()
            window.URL.revokeObjectURL(link.href)
          })
      },
      enterEmail() {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.$emit('openReportBookingModal');
          }
        });
      },
      scheduled(email) {
        this.$vs.notify({
          color: 'success',
          title: 'Agendamento',
          text: `Relatório solicitado com sucesso para o E-mail ${email}! Confira em instantes a caixa de entrada.`
        })
      },
      schedulingTime() {
        this.$vs.notify({
          color: 'danger',
          title: 'Agendamento',
          text: `Aguarde 5 segundos antes de solicitar novo envio de relatório`
        })
      },
      setTime(){
        if (!this.blockedTime){
          this.blockedTime = true;
          setTimeout(() => {
            this.blockedTime = false;
          }, 5000);
        }
      },
      datePtToEng(date) {
        date = date.split('/')
        return `${date[2]}-${date[1]}-${date[0]}`
      },
      finishAtConfig(config) {
        return {
          ...config,
          minDate: this.start_at
        }
      },
      parseDeliveryFee(address) {
        return 'R$ ' + (parseFloat((JSON.parse(address)).delivery_fee).toFixed(2)).replace('.', ',');
      },
      parseDeliveryCep(address) {
        return JSON.parse(address).cep;
      },
      parseDeliveryAddress(address) {
        const parsed = JSON.parse(address);
        return parsed.address + ', Nº ' + parsed.number;
      },
      parsePaymentData(data) {
        const type = JSON.parse(data).type;
        return type === 'card' ? 'Cartão' : (type === 'cash' ? 'Dinheiro' : 'Pix');
      },
      parseExtraPaymentInformation(data) {
        const parsed = JSON.parse(data);
        return parsed.months === undefined ? (parsed.money_change === undefined ? null : 'Troco para R$ ' + String(parsed.money_change).replace('.', ',')) : 'Parcelado em ' + parsed.months + 'x';
      },
      hasAddress(data) {
        return JSON.parse(data).address !== 'none';
      },
      hasPayment(data) {
        return JSON.parse(data).type !== 'none';
      }
    },
    created(){
      this.$events.off('ReportWarning')
      this.$events.on('ReportWarning', (event) => {
        if (event.tenantName === getCurrentTenant()) {
          if ( message !== null ) {
            this.$vs.notify({
                time: 3000, 
                color: 'danger',
                title: 'Problemas na criação da campanha!',
                text: message
            })
          }
        }
      })
    },
    components: {
      ChangeTimeDurationDropdown,
      VxTimeline,
      flatPickr,
      vSelect,
      UsersTable,
      ReportBookingModal
    }
  }
  </script>
  
  <style lang="scss">
  
  
  #table-report {
      width: 100%;
      overflow: auto;
  
      .vs-con-table {
        .product-name {
          max-width: 23rem;
        }
  
        .vs-table--header {
          display: flex;
          flex-wrap: wrap-reverse;
          margin-left: 1.5rem;
          margin-right: 1.5rem;
          > span {
            display: flex;
            flex-grow: 1;
          }
  
          .vs-table--search{
            padding-top: 0;
  
            .vs-table--search-input {
              padding: 0.9rem 2.5rem;
              font-size: 1rem;
  
              &+i {
                left: 1rem;
              }
  
              &:focus+i {
                left: 1rem;
              }
            }
          }
        }
  
        .vs-table {
          border-collapse: separate;
          border-spacing: 0 1.3rem;
          padding: 0 1rem;
  
          tr{
            box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
            td{
              padding: 10px;
              
  
              &:first-child{
                border-top-left-radius: .5rem;
                border-bottom-left-radius: .5rem;
              }
              &:last-child{
                border-top-right-radius: .5rem;
                border-bottom-right-radius: .5rem;
              }
            }
            td.td-check{
              padding: 20px !important;
            }
          }
        }
  
        .vs-table--thead{
          th {
            padding-top: 0;
            padding-bottom: 0;
  
            .vs-table-text{
              text-transform: uppercase;
              font-weight: 600;
              width: 100px;
            }
          }
          th.td-check{
            padding: 0 15px !important;
          }
          tr{
            background: none;
            box-shadow: none;
          }
        }
  
        .vs-table--pagination {
          justify-content: center;
        }
      }
    }
  
    .v-select {
      background: #fff;
    }
  
    /*! rtl:begin:ignore */
    #dashboard-analytics {
      .greet-user{
        position: relative;
  
        .decore-left{
          position: absolute;
          left:0;
          top: 0;
        }
        .decore-right{
          position: absolute;
          right:0;
          top: 0;
        }
      }
  
      @media(max-width: 576px) {
        .decore-left, .decore-right{
          width: 140px;
        }
      }
    }
    .no-address span{
      margin-left: 30%;
    }
    /*! rtl:end:ignore */
  </style>
  